// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum DesigoOpticLicenceType {
  SoftwareWithBase = 0,
  SoftwareWithTrend = 1,
  EmbeddedWithBase = 2,
  EmbeddedWithTrend = 3,
}
